import React from 'react';
import { CardHeaderProps } from './types';
import './Card.css';

const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  subtitle,
  action,
  avatar,
  className = '',
  sx = {},
}) => {
  const headerClasses = [
    'raith-card__header',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={headerClasses} style={sx}>
      <div className="raith-card__header-content">
        {avatar && (
          <div className="raith-card__avatar">
            {avatar}
          </div>
        )}
        <div className="raith-card__header-text">
          {title && (
            <h3 className="raith-card__title">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="raith-card__subtitle">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {action && (
        <div className="raith-card__action">
          {action}
        </div>
      )}
    </div>
  );
};

export default CardHeader;